import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import { useRef } from 'react';
import FormUpload from '../../../components/formInputs/FormUpload';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import useFormsIntegrationHelpers from '../../../hooks/useFormsIntegrationHelpers';
import { useParams } from 'react-router-dom';
import { getMedia, scrollToError } from '../../../utils/HelperFunctions';
import * as Yup from 'yup';
import Button from '../../../components/buttons/Button';
import FormDynamicSkeleton from '../../../components/loaders/FormDynamicSkeleton';

const VehicleModelsEditSeo = () => {
  const { t } = useTranslation();
  const { id: makeId, modelId: id } = useParams();
  const formRef = useRef(null);

  const { apiData, getDataLoading, handleSubmit, submitLoading } = useFormsIntegrationHelpers({
    queryKey: ['models', id],
    id,
    singleGetApi: `/admin/makes/${makeId}/models/${id}`,
    editApi: `/admin/models/${id}`,
    itemName: t('model'),
    // listRoute: '/models'
  });

  const initialValues = {
    ...apiData,
    body_types: null,
    vehicle_make: null,
    media: null,
    interior_colors: null,
    exterior_colors: null,
    vehicle_make_id: apiData?.vehicle_make?.id,
    body_type_ids: apiData?.body_types?.map((item: any) => item.id),
    image: getMedia(apiData?.media, 'image')?.url,
    meta_image: getMedia(apiData?.media, 'meta_image')?.url,
    brochure_en: getMedia(apiData?.media, 'brochure_en')?.url,
    brochure_ar: getMedia(apiData?.media, 'brochure_ar')?.url
  };

  const validationSchema = Yup.object({});

  if (getDataLoading)
    return (
      <FormDynamicSkeleton
        sections={[
          [
            { columns: 2, items: 2 },
            { columns: 2, items: 2, type: 'textarea' },
            { columns: 2, items: 1, type: 'textarea' },
          ],
        ]}
        buttons={1}
        noTitle
      />
    );

  return (
    <div className={'form_section'} ref={formRef}>
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          let value = { ...values, _method: 'POST' };
          if (id) {
            value = { ...value, _method: 'PUT' };
          }
          handleSubmit({ ...value });
        }}
      >
        {(formik) => (
          <Form>
            <div className="inputs_group">
              <FieldWrapper title={t('title_en')} inputName={`meta_title[en]`} inputPlaceholder={t('title_en')} input customPadding />
              <FieldWrapper title={t('title_ar')} inputName={`meta_title[ar]`} inputPlaceholder={t('title_ar')} input customPadding />
            </div>
            <div className="inputs_group">
              <FieldWrapper title={t('description_en')} inputName={`meta_description[en]`} inputPlaceholder={t('description_en')} textArea customPadding />
              <FieldWrapper title={t('description_ar')} inputName={`meta_description[ar]`} inputPlaceholder={t('description_ar')} textArea customPadding />
            </div>
            <div className="inputs_group">
              <FieldWrapper>
                <FormUpload errors={formik?.errors.meta_image as string} touched={formik?.touched?.meta_image as boolean} formik={formik} name={`meta_image`} label={t('image')} />
              </FieldWrapper>
              <FieldWrapper noPadding />
            </div>
            <div className="form_button reverse">
              <Button
                loading={submitLoading}
                onClick={() => {
                  scrollToError(!formik.isValid, formRef);
                }}
              >
                <span className="bold">{t('save')}</span>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default VehicleModelsEditSeo;
